export type UpdateIfConversionRulesRequest = {
  envCopyIfDfnCnvRule: EnvCopyIfDfnCnvRuleWithIdx[];
};

export type EnvCopyIfDfnCnvRuleWithIdx = {
  idx: number;
  ifDfnCnvRuleId: string;
  envrnmntIdFrom: string;
  envrnmntIdTo: string;
  cpntId: string;
  bdryId: string;
  ifItmGrpNum: number;
  ifItmGrpLgclName: string;
  ifItmNum: number;
  ifDfnCnvRuleTypeCd: string;
  rplcmntFromAttrStngVal: string;
  rplcmntToAttrStngVal: string;
  prefxStngVal: string;
  updateDateTime?: string;
};
